/* eslint-disable perfectionist/sort-imports */
import 'src/global.css';

import ThemeProvider from 'src/theme';

import Router from 'src/routes/sections';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import { MotionLazy } from 'src/components/animate/motion-lazy';
import ProgressBar from 'src/components/progress-bar';
import { SettingsDrawer, SettingsProvider } from 'src/components/settings';
import { SnackbarProvider } from 'src/components/snackbar';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AuthProvider } from 'src/auth/context/jwt';
import CardProvider from './contexts/card-context';
import JobRoleProvider from './contexts/job-role-context';
import { LoadingProvider } from './contexts/loading-context';
import NotificationProvider from './contexts/notification-context';
import OrganizationProvider from './contexts/organization-context';
import PaymentUserProvider from './contexts/payment-user-context';
import PopupProvider from './contexts/popup-context';
import SkillProvider from './contexts/skill-context';
import SubscriptionProvider from './contexts/subscription-context';
import UserProvider from './contexts/user-context';
import { EvaluationProvider } from './contexts/evaluation-provider';


const ProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <AuthProvider>
        <OrganizationProvider>
          <UserProvider>
            <SkillProvider>
             <EvaluationProvider>
              <JobRoleProvider>
                <PopupProvider>
                  <NotificationProvider>
                    <SubscriptionProvider>
                      <CardProvider>
                        <PaymentUserProvider>
                          <LoadingProvider>{children}</LoadingProvider>
                        </PaymentUserProvider>
                      </CardProvider>
                    </SubscriptionProvider>
                  </NotificationProvider>
                </PopupProvider>
              </JobRoleProvider>
             </EvaluationProvider> 
            </SkillProvider>
          </UserProvider>
        </OrganizationProvider>
      </AuthProvider>
    </LocalizationProvider>
  );
};

export default function App() {
  const charAt = `
   ░░░░░░░
      ▒▒
      ▒▒
      ▓▓
      ██
  `;

  console.info(`%c${charAt}`, 'color: #17DAE3');

  useScrollToTop();

  return (
    <SettingsProvider
      defaultSettings={{
        themeMode: 'light', // 'light' | 'dark'
        themeDirection: 'ltr', //  'rtl' | 'ltr'
        themeContrast: 'default', // 'default' | 'bold'
        themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
        themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
        themeStretch: false,
      }}
    >
      <ThemeProvider>
        <SnackbarProvider>
          <ProviderWrapper>
            <MotionLazy>
              <SettingsDrawer />
              <ProgressBar />
              <Router />
            </MotionLazy>
          </ProviderWrapper>
        </SnackbarProvider>
      </ThemeProvider>
    </SettingsProvider>
  );
}
